import { Flex, RemoteImage } from '@banhala/ui-kit';
import { View } from 'react-native';

export const ProfileAvatar = ({ image }: { image: string }) => {
  return (
    <Flex.Center
      padding={{
        vertical: 6,
      }}
      flexShrink={0}
    >
      <View
        style={{
          borderRadius: 9999,
          width: 36,
          height: 36,
          overflow: 'hidden',
          borderWidth: 1,
          borderColor: '#00000014',
        }}
      >
        <RemoteImage width={36} height={36} uri={image} />
      </View>
    </Flex.Center>
  );
};
